<template>
  <div>
    <Form :options="formOptions" />
  </div>
</template>

<script>
import Form from '@/components/form/Form.vue'
import { buildPhoneExtensionFormOptions } from './phoneExtensionFormOptions'

export default {
  components: {
    Form
  },
  data () {
    return {
      formOptions: buildPhoneExtensionFormOptions(this.$route)
    }
  }
}
</script>
